import { ParamMap } from '@angular/router';

import { ContractStatus } from '@gi/enums/contract-status.enum';
import { ProspectsQueryParams } from '@gi/enums/prospects-query-params.enum';
import { ProspectsFilters } from '@gi/interfaces/prospects-filters';
import { FiltersParams, HttpHelper } from '@helpers/http.helper';
import { businessUnitsParam, contributorsParam } from '@helpers/query-params.helper';

export class ProspectsHelper {
  static toParams(filters: ProspectsFilters): FiltersParams {
    return {
      [ProspectsQueryParams.businessUnits]: filters?.businessUnits?.length
        ? HttpHelper.idsFilter(filters?.businessUnits)
        : undefined,
      [ProspectsQueryParams.owners]: filters?.owners?.[0]?.id ? HttpHelper.idsFilter(filters?.owners) : undefined,
      [ProspectsQueryParams.withoutSalesRepresentativeUser]: filters?.owners?.[0]?.id === null ? true : undefined,
      [ProspectsQueryParams.withoutContract]: filters?.prospectWithoutContract ? true : undefined,
      [ProspectsQueryParams.contractStatus]: filters?.contractStatus?.length
        ? filters.contractStatus.join('|')
        : undefined,
      [ProspectsQueryParams.companyLinked]: typeof filters?.company === 'boolean' ? filters?.company : undefined,
      [ProspectsQueryParams.prestations]: filters?.tasks?.length ? HttpHelper.idsFilter(filters?.tasks) : undefined,
      [ProspectsQueryParams.tiimeBusinessProAccountIntention]: filters?.tiimeBusinessProAccountIntentions?.length
        ? filters.tiimeBusinessProAccountIntentions.join('|')
        : undefined,
      [ProspectsQueryParams.prospectAppointmentDate]:
        filters.appointmentStartDate || filters.appointmentEndDate
          ? HttpHelper.dateFilter(filters.appointmentStartDate, filters.appointmentEndDate)
          : filters.withoutAppointment === true
            ? null
            : undefined,
      [ProspectsQueryParams.acquisitionChannels]: filters.acquisitionChannel ?? undefined
    };
  }

  static fromParams(params: ParamMap): ProspectsFilters {
    const filters: ProspectsFilters = {};

    if (params.has(ProspectsQueryParams.withoutContract)) {
      filters.prospectWithoutContract = params.get(ProspectsQueryParams.withoutContract) === 'true';
    }

    if (params.has(ProspectsQueryParams.companyLinked)) {
      filters.company = params.get(ProspectsQueryParams.companyLinked) === 'true';
    }

    if (params.has(ProspectsQueryParams.contractStatus)) {
      filters.contractStatus = params.get(ProspectsQueryParams.contractStatus).split('|') as ContractStatus[];
    }

    if (params.has(ProspectsQueryParams.owners)) {
      filters.owners = contributorsParam(params.get(ProspectsQueryParams.owners));
    }

    if (params.has(ProspectsQueryParams.businessUnits)) {
      filters.businessUnits = businessUnitsParam(params.get(ProspectsQueryParams.businessUnits));
    }

    return filters;
  }

  static activeFiltersLength(filters: ProspectsFilters): number {
    return (
      (filters?.businessUnits?.length ? 1 : 0) +
      (filters?.owners?.length ? 1 : 0) +
      (typeof filters?.company === 'boolean' ? 1 : 0) +
      (filters?.contractStatus?.length ? 1 : 0) +
      (filters?.tasks?.length ? 1 : 0) +
      (filters?.tiimeBusinessProAccountIntentions?.length ? 1 : 0) +
      (!!filters?.appointmentStartDate || !!filters?.appointmentEndDate || filters?.withoutAppointment ? 1 : 0) +
      (filters?.acquisitionChannel ? 1 : 0)
    );
  }
}
